<script setup lang="ts">
import { useToast } from '@/composables/useToast'
import ToastItem from './ToastItem.vue'

const { toasts } = useToast()
</script>

<template>
  <div class="toast-container">
    <TransitionGroup name="toast">
      <ToastItem 
        v-for="toast in toasts" 
        :key="toast.id" 
        :toast="toast" 
      />
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-container {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 9999;
  display: flex;
  flex-direction: column-reverse; /* Newest appear at the bottom */
  gap: var(--sp-16); /* Added gap to replace margin-bottom on items for better flex control */
  pointer-events: none;
}

/* Toast Transitions */
.toast-enter-active,
.toast-leave-active {
  transition: all calc(0.4s * var(--motion-scale)) cubic-bezier(0.34, 1.56, 0.64, 1);
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100%) translateY(20px) scale(0.9);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100%) translateY(-20px) scale(0.9);
}

.toast-leave-active {
  position: absolute; /* Ensure smooth removal from list */
}

/* Smooth shuffling when item is removed */
.toast-move {
  transition: all calc(0.3s * var(--motion-scale)) ease;
}

/* Telefon (≤768): üst çubuğun altında, iki yanda 16px — sağdan taşmaz */
@media (max-width: 768px) {
  .toast-container { top: calc(64px + env(safe-area-inset-top, 0px)); bottom: auto; left: var(--sp-16); right: var(--sp-16); flex-direction: column; gap: var(--sp-8); }
  .toast-enter-from { transform: translateY(-16px); }
  .toast-leave-to { transform: translateY(-16px); }
}
</style>
